import Vue from 'vue';

Vue.filter('asUpperCase', (text) => String(text).toUpperCase());
